import { Clock } from 'lucide-react';

import logo from '@/assets/OKYC logo.webp';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

import { useLogout } from '../hooks/use-logout';

export function AwaitingApprovalPage() {
  const { mutate: logout, isPending: isLoggingOut } = useLogout();

  return (
    <div className="fixed inset-0 flex overflow-y-auto bg-[#F5F7F9] p-4">
      <Card className="m-auto w-full max-w-[390px] rounded-[5px] border border-[#D4DAE0] bg-white p-6">
        <CardHeader className="space-y-6 p-0 text-center">
          <img src={logo} alt="OKYC Logo" className="mx-auto h-16 w-auto" />
          <h1 className="text-[20px] font-semibold leading-[120%] text-[#051923]">
            Your account is awaiting verification
          </h1>
        </CardHeader>

        <CardContent className="mt-6 space-y-6 p-0 text-center">
          <div className="flex flex-col items-center space-y-4">
            <Clock className="h-10 w-10 text-[#131313]" />
            <p className="text-[16px] text-[#051923]">
              An administrator is reviewing your details. We will email you as soon as a decision
              has been made.
            </p>
            <Button
              onClick={() => logout()}
              disabled={isLoggingOut}
              className="h-[45px] w-full rounded-[5px] bg-[#131313] text-[18px] font-medium text-white"
            >
              Log out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
